var React = require('react');

function AcademiaIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 21.1942V22.4H13.2272V21.1942C15.0281 21.1624 15.913 20.7822 15.913 19.7656C15.913 19.4173 15.7817 19.0037 15.6175 18.528L14.4026 15.5707H6.01683C5.31582 17.3429 4.79048 18.6664 4.7166 18.8462C3.93023 20.7726 5.01047 21.0081 6.86394 21.1926C6.86887 21.1926 6.87215 21.1942 6.87544 21.1942C6.87544 21.1942 6.87544 21.1942 6.87708 21.1942L6.87544 22.4H0V21.1942C0.883234 21.0351 1.60394 20.8776 1.8978 20.0202L8.90622 2.5055L7.85717 0H13.7837L22.0694 20.0202C22.2155 20.4163 22.4699 20.6708 22.8016 20.8442C23.1332 21.0192 23.542 21.1146 24 21.1942ZM13.8946 12.9684L10.6774 4.71578C10.1485 6.1236 8.77553 9.7833 7.57884 12.9684H13.8946Z","fill":"black"}));
}

AcademiaIcon.defaultProps = {"width":"24","height":"23","viewBox":"0 0 24 23","fill":"none"};

module.exports = AcademiaIcon;

AcademiaIcon.default = AcademiaIcon;
